import { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getFirestore } from "../../config/firebase";
import { sendEmailBackup, initEmailJS } from "../../config/emailjs";
import { FECHA_TEST_DRIVE } from "./constants";
import { getStoredUtms } from "../../utils/utm";

const useInscripcionSubmit = (config) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [formLoadTime, setFormLoadTime] = useState(0);

  const db = getFirestore();

  const [meta, setMeta] = useState({
    ip: "",
    device: navigator.userAgent,
  });

  useEffect(() => {
    setFormLoadTime(Date.now());
    initEmailJS();

    (async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const { ip } = await res.json();
        setMeta((m) => ({ ...m, ip }));
      } catch (err) {
        console.error("IP fetch error", err);
      }
    })();
  }, []);

  const submitInscripcion = async (formData) => {
    const ms = Date.now() - formLoadTime;
    if (ms < 5000) {
      setStatus("error");
      return;
    }

    setLoading(true);
    setStatus("cargando");

    const utms = getStoredUtms();
    const utm_source = utms.utm_source || "";
    const utm_medium = utms.utm_medium || "";
    const utm_campaign = utms.utm_campaign || "";
    const utm_term = utms.utm_term || "";
    const utm_content = utms.utm_content || "";

    const payload = {
      nombre: formData.nombre,
      apellido: formData.apellido,
      name: `${formData.nombre} ${formData.apellido}`,
      email: formData.email || "",
      dni: formData.dni,
      phone: formData.phone,
      fechaTestDrive: FECHA_TEST_DRIVE.label,
      marcaSeleccionada: formData.marcaSeleccionada || "GAC Aion UT",
      tipoFormulario: formData.tipoFormulario || "aion-ut",
      sede: "",
      ubicacionTestDrive: "",
      sucursalSubtitulo: "",
      ip: meta.ip,
      device: meta.device,
      origen: [utm_source, utm_medium].filter(Boolean).join(" "),
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      fecha: new Date().toLocaleString("es-AR", {
        timeZone: "America/Argentina/Buenos_Aires",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }),
      fechaISO: new Date().toISOString(),
    };

    try {
      const ref = db.collection("eventos").doc(config.firebaseDocId);
      await ref.update({
        inscriptos: firebase.firestore.FieldValue.arrayUnion(payload),
      });

      const emailResult = await sendEmailBackup(payload, {
        emailEventName: config.emailEventName,
        emailjsTemplateId: config.emailjsTemplateId,
      });
      if (!emailResult.success) {
        console.warn("Backup por email falló, pero Firebase se guardó correctamente:", emailResult.error);
      }

      setStatus("ok");
    } catch (err) {
      console.error("Error en el envío:", err);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return { loading, status, setStatus, submitInscripcion };
};

export default useInscripcionSubmit;
